import React from 'react';
import autobind from 'core-decorators/lib/autobind';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { STATES as ENGINE_STATES, VIDEO_EVENTS } from 'playable/dist/src/constants';
import bi from 'shared/bi/bi';
import { updateLiveStatus } from 'widget/redux/client/actions/videos';
import liveStatuses from '@wix/wix-vod-shared/src/common/constants/live-statuses';

@connect(null, {
  updateLiveStatus,
})
export default class LiveVideoStatusUpdater extends React.Component {

  static propTypes = {
    videoItem: PropTypes.object,
    updateLiveStatus: PropTypes.func,
    eventEmitter: PropTypes.object,
    channelId: PropTypes.string,
  };

  componentDidMount() {
    const { eventEmitter } = this.props;
    eventEmitter.on(VIDEO_EVENTS.LIVE_STATE_CHANGED, this.onLiveStatusChanged);
  }

  componentWillUnmount() {
    const { eventEmitter } = this.props;
    eventEmitter.off(VIDEO_EVENTS.LIVE_STATE_CHANGED, this.onLiveStatusChanged);
  }

  @autobind
  onLiveStatusChanged({ nextState }) {
    const { updateLiveStatus, videoItem, channelId } = this.props;

    if (nextState === ENGINE_STATES.ENDED) {
      bi.log('widget.live.video.ended', {
        channelID: channelId,
        videoID: videoItem.id,
      });
      updateLiveStatus({ ...videoItem, itemType: liveStatuses.FINALIZING });
    }
  }

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/new-player/containers/live-video-updaters/components/live-video-status-updater.js